import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import Sidebar from "./sidebar"

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const [isSidebarOpen, setSidebarOpen] = useState(false)
  return (
    <>
      <Header
        isSidebarOpen={isSidebarOpen}
        setSidebarOpen={setSidebarOpen}
        siteTitle={data.site.siteMetadata?.title || `Title`}
      />
      <Sidebar
        location={location}
        isSidebarOpen={isSidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <main className="w-full m-auto max-w-[1280px]">{children}</main>
      <Footer />
    </>
  )
}

export default Layout
